import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(landingpage)/page.tsx");
